import {getEnrollmentIdFieldLabel, shouldShowEnrollmentIdField} from "helpers"
import {useTranslation} from "react-i18next"
import {useModel} from "./useModel"

type UseShowEnrollmentIdFieldResult = {
    isVisible: boolean
    /** Students: configurable field label. Staff/admin: always the default Enrollment ID label. */
    label: string
}

/**
 * Enrollment ID field visibility and label.
 * When the field setting is inactive, it is hidden for student role only.
 * Label from settings (getFieldLabel) applies to students only; staff always see "Enrollment ID".
 */
export const useShowEnrollmentIdField = (defaultLabel?: string): UseShowEnrollmentIdFieldResult => {
    const model = useModel()
    const {t} = useTranslation(["common", "user"])
    const fallbackLabel = defaultLabel ?? t("common:studentInfo.enrollmentID")

    return {
        isVisible: shouldShowEnrollmentIdField(model),
        label: getEnrollmentIdFieldLabel(model, fallbackLabel)
    }
}
